export class ImageListResult {
    resCode: number;
    resMsg: string;
    resData: any;
    totalPage: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/result/image-list-result.ts